module.exports = "<dx-box direction=\"row\"\n        width=\"100%\">\n    <dxi-item [ratio]=\"1\">\n        <div class=\"caption\">\n            {{caption}}\n        </div>\n    </dxi-item>\n</dx-box>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-view-header/data-view-header.component.html
// module id = ./src/app/components/data-view-header/data-view-header.component.html
// module chunks = main